import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNameMerge } from '@/lib/utils';
import { measureLinesFromHtml, stripHtmlTags } from '@/utils/textUtils';
import DOMPurify from 'dompurify';
import { DateTime } from 'luxon';
import * as React from 'react';
import { cardTitleContainerVariants, cardTitleVariants } from '../../campaignCardStyles';
var UpdateContent = function (_a) {
    var author = _a.author, description = _a.description, layout = _a.layout, postedAt = _a.postedAt, title = _a.title;
    var convertPostedDate = DateTime.fromFormat(postedAt, 'yyyy-MM-dd HH:mm:ss').toFormat('dd LLL yy h:mma');
    var titleRef = React.useRef(null);
    var _b = React.useState(0), titleLines = _b[0], setTitleLines = _b[1];
    var getLineClampNumberFromTitle = function () {
        var totalLines = 8 - titleLines;
        var linesToClampTo = totalLines >= 3 ? totalLines : 3;
        return "md:line-clamp-".concat(linesToClampTo);
    };
    React.useEffect(function () {
        var updateLineCount = function () {
            if (titleRef.current) {
                var count = measureLinesFromHtml(titleRef.current);
                setTitleLines(count);
            }
        };
        updateLineCount();
        window.addEventListener('resize', updateLineCount);
        return function () {
            window.removeEventListener('resize', updateLineCount);
        };
    }, [title]);
    var sanitisedDescription = DOMPurify.sanitize(description);
    return (_jsxs("div", { className: "flex flex-col justify-center gap-3 divide-y divide-neutral-200 md:flex-1", children: [_jsxs("div", { className: classNameMerge(cardTitleContainerVariants({ layout: layout })), "data-testid": "campaign-card-title-container", children: [_jsx("h3", { className: classNameMerge(cardTitleVariants({ layout: layout })), "data-testid": "campaign-card-title", ref: titleRef, children: title }), _jsxs("h4", { className: "font-sans tracking-[-0.3px] text-gray-600 text-xs flex flex-col gap-1", "data-testid": "campaign-card-author", children: [_jsx("p", { className: "min-w-fit", "data-testid": "campaign-card-posted-date", children: convertPostedDate }), _jsx("p", { className: "flex-1 truncate max-md:w-full", "data-testid": "campaign-card-author-name", children: author })] })] }), _jsx("div", { className: "line-clamp-3 ".concat(getLineClampNumberFromTitle(), " text-xs sm:text-sm text-neutral-800 leading-[1rem] sm:leading-[1.2rem] md:leading-[1.4rem] pt-[0.75rem]"), dangerouslySetInnerHTML: { __html: stripHtmlTags(sanitisedDescription) }, "data-testid": "campaign-card-description" })] }));
};
UpdateContent.displayName = 'UpdateContent';
export default UpdateContent;
